"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
exports.recursion = function (f) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return f.apply(void 0, [function () {
            var argsi = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                argsi[_i] = arguments[_i];
            }
            return exports.recursion(f).apply(void 0, argsi);
        }].concat(args));
}; };
exports.findAndReturn = function (callback, collection) {
    for (var i = 0; i < collection.length; i++) {
        var value = callback(collection[i]);
        if (!ramda_1.isNil(value)) {
            return value;
        }
    }
    return null;
};
exports.pipeline = function (argument) {
    var inputs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        inputs[_i - 1] = arguments[_i];
    }
    return ramda_1.reduce(function (value, func) { return func(value); }, argument, inputs);
};
exports.findById = function (id, data) { return ramda_1.find(function (o) { return o.id === id; }, data); };
exports.mapIndexed = ramda_1.curry(ramda_1.addIndex(ramda_1.map));
exports.sortBySortIndex = ramda_1.sortBy(ramda_1.prop("sort_index"));
exports.compact = ramda_1.reject(ramda_1.isNil);
exports.maxAll = function (list) { return list.length === 0 ? null : ramda_1.reduce(ramda_1.max, Number.MIN_VALUE, list); };
exports.minAll = function (list) { return list.length === 0 ? null : ramda_1.reduce(ramda_1.min, Infinity, list); };
//# sourceMappingURL=functional.js.map